module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.changeSuccess) ? _c('form', {
    staticClass: "form-horizontal password-reset-form",
    attrs: {
      "id": "password-reset-form",
      "action": _vm.resetUrl
    },
    on: {
      "submit": _vm.submit
    }
  }, [_c('h1', [_vm._v("Reset Your Password")]), _vm._v(" "), (_vm.alert.visible) ? _c('div', {
    staticClass: "alert",
    class: _vm.alert.class
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.alert.msg) + "\n\t\t")]) : _vm._e(), _vm._v(" "), _c('FormGroup', {
    attrs: {
      "label": "New Password",
      "col-class": "col-md-4"
    }
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "name": "password"
    }
  })]), _vm._v(" "), _c('FormGroup', {
    attrs: {
      "label": "Confirm Password",
      "col-class": "col-md-4"
    }
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "name": "confirm"
    }
  })]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "token"
    },
    domProps: {
      "value": _vm.token
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v("Change Password")])], 1) : _vm._e(), _vm._v(" "), (_vm.changeSuccess) ? _c('div', {
    staticClass: "success-box"
  }, [_vm._v("\n\t\tPassword changed successfully. You can now "), _c('a', {
    attrs: {
      "href": "/login"
    }
  }, [_vm._v("login")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29bdbb75","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ResetPassword.vue
// module id = 280
// module chunks = 0